import { useMemo } from 'react'

export const DOTS = '...'

const range = (start: number, end: number) => {
  const length = end - start + 1
  return Array.from({ length }, (_, idx) => idx + start)
}

export const usePagination = ({
  totalPages,
  currentPage,
}: {
  totalPages: number;
  currentPage: number;
}) => {
  const paginationRange = useMemo(() => {
    // totalPaginationItemsDisplayed is firstPage + lastPage + currentPage + 2*DOTS
    const totalPaginationItemsDisplayed = 5 // this is the page navigation numbers displayed at the bottom of the table

    /*
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPages]
    */
    if (totalPages <= totalPaginationItemsDisplayed) {
      return range(1, totalPages)
    }

    const shouldShowLeftDots = currentPage > 3
    const shouldShowRightDots = currentPage < totalPages - 2

    const firstPageIndex = 1
    const lastPageIndex = totalPages

    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftRange = range(1, 3)

      return [...leftRange, DOTS, totalPages]
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightRange = range(totalPages - 2, totalPages)
      return [firstPageIndex, DOTS, ...rightRange]
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      return [firstPageIndex, DOTS, currentPage, DOTS, lastPageIndex]
    }
  }, [totalPages, currentPage])

  return paginationRange
}
